/* ============================================================
   YOLÈTE — « Atelier Éditorial » · interactions
   Chargé en dernier (après common.js + script de page).
   100 % additif. Neutralisé si prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var raf = window.requestAnimationFrame.bind(window);

  /* ---------- 1. Barre de progression ---------- */
  (function () {
    var bar = document.createElement('div');
    bar.className = 'scroll-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.setProperty('--p', (max > 0 ? h.scrollTop / max : 0).toFixed(4));
      ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(update); } }, { passive: true });
    update();
  })();

  /* ---------- 3. Burger croix ---------- */
  (function () {
    var burger = document.getElementById('burger');
    var nav = document.getElementById('navLinks');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () { burger.classList.toggle('is-open', nav.classList.contains('open')); });
    nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') burger.classList.remove('is-open'); });
  })();

  if (!reduce) {
    /* ---------- 4. Parallax (hero + [data-parallax]) ---------- */
    (function () {
      var heroImg = document.querySelector('.hero-visual img');
      var items = [].slice.call(document.querySelectorAll('[data-parallax]'));
      var ticking = false;
      function update() {
        var y = scrollY;
        if (heroImg) heroImg.style.transform = 'translateY(' + (y * 0.14).toFixed(1) + 'px) scale(1.05)';
        items.forEach(function (el) {
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
          var rect = el.getBoundingClientRect();
          var off = (rect.top + rect.height / 2 - innerHeight / 2) * -speed;
          el.style.transform = 'translateY(' + off.toFixed(1) + 'px)';
        });
        ticking = false;
      }
      function onScroll() { if (!ticking) { ticking = true; raf(update); } }
      // on laisse l'animation d'entrée du hero se jouer avant de prendre la main
      setTimeout(function () { addEventListener('scroll', onScroll, { passive: true }); update(); }, heroImg ? 1600 : 0);
      if (items.length && !heroImg) { addEventListener('scroll', onScroll, { passive: true }); update(); }
    })();

    /* ---------- 5. Révélation des chiffres clés (montée sous masque, en cascade) ---------- */
    (function () {
      var groups = [].slice.call(document.querySelectorAll('.story-facts, .atelier-facts'));
      if (!groups.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          [].slice.call(en.target.querySelectorAll('.fact')).forEach(function (f, i) {
            var st = f.querySelector('strong'); if (st) st.style.transitionDelay = (i * 0.13) + 's';
            var sp = f.querySelector('span'); if (sp) sp.style.transitionDelay = (i * 0.13 + 0.18) + 's';
            raf(function () { f.classList.add('in'); });
          });
        });
      }, { threshold: 0.35 });
      groups.forEach(function (g) { io.observe(g); });
    })();

    /* ---------- 6. Boutons magnétiques (desktop) ---------- */
    if (finePointer) (function () {
      [].slice.call(document.querySelectorAll('.btn-dark, .btn-ghost, .btn-brass')).forEach(function (btn) {
        btn.addEventListener('pointermove', function (e) {
          var r = btn.getBoundingClientRect();
          var dx = (e.clientX - r.left - r.width / 2) / r.width;
          var dy = (e.clientY - r.top - r.height / 2) / r.height;
          btn.style.transform = 'translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 6 - 2).toFixed(1) + 'px)';
        });
        btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
      });
    })();

    /* ---------- 7. Configurateur : fondu au changement ---------- */
    (function () {
      ['beltStrap', 'beltBuckle'].forEach(function (id) {
        var img = document.getElementById(id);
        if (!img) return;
        img.addEventListener('load', function () {
          img.classList.remove('swap'); void img.offsetWidth; img.classList.add('swap');
        });
      });
    })();
  }

  /* ---------- 8. Navigation instantanée ----------
     Plus d'interception au clic ni de voile : la navigation est immédiate.
     Le léger fondu d'arrivée (150ms) est géré en pur CSS (enhance.css). */

  /* ---------- 9. Vidéos : autoplay robuste (surtout iOS) ----------
     Toutes les vidéos de la page, pas seulement celle du bandeau d'accueil :
     la carte « L'Atelier » restait figée sur son image sur téléphone. */
  Array.prototype.forEach.call(document.querySelectorAll('video'), function (video) {
    if (reduce) {
      video.removeAttribute('autoplay');
      video.pause();
      video.setAttribute('controls', '');
      return;
    }
    /* preload="none" empêche iOS de démarrer seul : on demande au moins les métadonnées */
    if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'metadata');
    // iOS n'autorise l'autoplay que si ces propriétés sont posées côté JS aussi
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function tryPlay() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    // relancer dès que des données arrivent (le fichier est léger => rapide)
    ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (ev) {
      video.addEventListener(ev, tryPlay);
    });
    tryPlay();

    // filet de sécurité : relancer au tout premier geste si iOS a bloqué
    function onFirst() {
      tryPlay();
      document.removeEventListener('touchstart', onFirst);
      document.removeEventListener('pointerdown', onFirst);
      document.removeEventListener('scroll', onFirst);
    }
    document.addEventListener('touchstart', onFirst, { passive: true });
    document.addEventListener('pointerdown', onFirst, { passive: true });
    document.addEventListener('scroll', onFirst, { passive: true });

    // pause hors écran pour économiser, reprise en revenant
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) tryPlay();
          else video.pause();
        });
      }, { threshold: 0.1 });
      io.observe(video);
    }
  });

  /* ---------- 10. Formulaires d'inscription (.js-signup : newsletter + offre −10%) ----------
     Scopé à .js-signup pour ne pas entrer en conflit avec le handler #newsForm de script.js
     sur les pages boutique. La landing (sans script.js) marque ses deux formulaires .js-signup. */
  (function () {
    var forms = [].slice.call(document.querySelectorAll('.js-signup'));
    forms.forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (window.Shopify) return;   /* theme : soumission reelle au formulaire client */
        e.preventDefault();
        f.reset();
        if (typeof toast === 'function') toast('Merci pour votre inscription');
      });
    });
  })();

  /* ---------- 11. Fenêtre newsletter, offre de bienvenue −10 % ----------
     Déclenchement au PREMIER des trois signaux : temps, défilement, ou
     intention de sortie. Un simple délai court fait apparaître la fenêtre
     avant que le visiteur ait vu une seule boucle, donc avant d'avoir envie
     de quoi que ce soit. Le défilement rattrape ceux qui vont vite, et
     l'intention de sortie rattrape ceux qui partent.
     Le code de réduction doit exister dans Shopify pour être honoré. */
  (function () {
    var CFG = {
      delai: 10000,          /* millisecondes avant affichage (10 s, demande client) */
      defilement: 0.45,      /* part de la page parcourue */
      sortie: true,          /* intention de sortie, ordinateur seulement */
      code: 'BIENVENUE10',
      repos: 30,             /* jours avant de reproposer après un refus */
      /* Textes. Sur le thème Shopify, la section « Yolète · Fenêtre lettre »
         les remplace par window.YOLETE_NL, donc sans toucher à ce fichier.
         Ce qui est ici reste le comportement par défaut, notamment sur Vercel. */
      surtitre: 'La lettre Yolète',
      titre: 'Votre première boucle',
      accent: '−10 %',
      texte: 'Nouvelles collections et éditions limitées en avant-première. Sans spam, promis.',
      champ: 'Votre adresse e-mail',
      bouton: 'Je reçois mes −10 %',
      refus: 'Non merci',
      merci: 'Merci. Votre code de bienvenue',
      fine: 'À saisir au moment du paiement.',
      image: 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/campaign__buckle-fish.jpg',
      mode: 'lettre',        /* 'pub' : l'ouverture automatique montre la publicité réglée dans le thème */
      pub: null
    };
    if (window.YOLETE_NL) {
      for (var k in window.YOLETE_NL) {
        var v = window.YOLETE_NL[k];
        if (v !== '' && v !== null && v !== undefined) CFG[k] = v;
      }
    }
    /* Lancement (25 sept 2026) : la fenêtre annonçait une sortie « en novembre ».
       Dès qu'une pièce de maroquinerie est achetable, et tant que le texte réglé
       dans le thème parle encore de sortie, elle annonce la collection en ligne.
       Un nouveau texte saisi dans le thème reprend la main de lui-même. */
    var maroListe = (window.MAROQUINERIE && window.MAROQUINERIE.length) ? window.MAROQUINERIE
      : ((window.SHOP && window.SHOP.sacs) || []);   /* données brutes du thème, présentes sur presque toutes les pages */
    var maroEnVente = maroListe.some(function (p) { return p.available && p.price > 0; });
    if (maroEnVente && /novembre|sortie|ouverture/i.test([CFG.titre, CFG.accent, CFG.texte].join(' '))) {
      CFG.titre = 'La collection maroquinerie';
      CFG.accent = 'est en ligne';
      CFG.texte = 'Inscrivez-vous à la lettre et profitez de −10\u202f% sur la collection avec le code ' + (CFG.code || 'MAROQUINERIE10') + '.';
      CFG.bouton = 'Je reçois mon code';
      CFG.merci = 'Merci. Votre code pour la collection';
      CFG.fine = 'À saisir au moment du paiement.';
    }
    function ech(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    /* interrupteur de la section, sans publication ; dans Personnaliser on continue,
       pour que l'aperçu reste possible même fenêtre désactivée */
    if (CFG.desactive && !(window.Shopify && Shopify.designMode)) return;
    var EXCLUES = ['/pages/personnalisation'];   /* on n'interrompt pas la composition */
    var K_VU = 'yolete_nl_refus', K_OK = 'yolete_nl_inscrit';

    function bloque() {
      try {
        if (localStorage.getItem(K_OK)) return true;
        var t = +localStorage.getItem(K_VU) || 0;
        if (t && Date.now() - t < CFG.repos * 864e5) return true;
      } catch (e) {}
      return EXCLUES.some(function (p) { return location.pathname.indexOf(p) !== -1; });
    }
    /* La fenêtre ne s'invite plus d'elle-même dans ces cas, mais elle reste
       ouvrable à la demande : une visiteuse qui clique « Être prévenue » sur une
       pièce pas encore sortie doit l'obtenir, même si elle a refusé la semaine
       dernière ou si elle est déjà inscrite. */
    /* Pas d'ouverture automatique dans l'éditeur de thème : elle couvrirait l'aperçu. */
    var auto = !bloque() && !(window.Shopify && Shopify.designMode);

    var ouvert = false, avant = null, timer = null, el = null;

    function construire() {
      el = document.createElement('div');
      el.className = 'nl-pop';
      el.innerHTML =
        '<div class="nl-back" data-nl-close></div>' +
        '<div class="nl-box" role="dialog" aria-modal="true" aria-labelledby="nlTitre">' +
          '<button class="nl-x" type="button" aria-label="Fermer" data-nl-close>&times;</button>' +
          '<div class="nl-media"><img src="' + ech(CFG.image) + '" alt="" decoding="async" /></div>' +
          '<div class="nl-body">' +
            '<p class="nl-eyebrow">' + ech(CFG.surtitre) + '</p>' +
            '<h2 id="nlTitre">' + ech(CFG.titre) +
              (CFG.accent ? ' <em>' + ech(CFG.accent) + '</em>' : '') + '</h2>' +
            '<p class="nl-txt">' + ech(CFG.texte) + '</p>' +
            '<form class="nl-form" method="post" action="/contact#contact_form" accept-charset="UTF-8" novalidate>' +
              '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="' + ech(CFG.tags || 'newsletter,bienvenue10') + '">' +
              '<input type="email" name="contact[email]" required placeholder="' + ech(CFG.champ) + '" aria-label="' + ech(CFG.champ) + '" />' +
              '<button type="submit" class="btn btn-dark">' + ech(CFG.bouton) + '</button>' +
            '</form>' +
            '<p class="nl-merci" hidden>' + ech(CFG.merci) + '<br><strong class="nl-code"></strong><br>' +
              '<span class="nl-fine">' + ech(CFG.fine) + '</span></p>' +
            '<button class="nl-non" type="button" data-nl-close>' + ech(CFG.refus) + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-nl-close]')) fermer(true);
      });
      el.querySelector('.nl-form').addEventListener('submit', function (e) {
        var i = this.querySelector('input[type=email]');
        if (window.Shopify) { if (!i.value || i.value.indexOf('@') < 1) { e.preventDefault(); i.focus(); } else { try { localStorage.setItem(K_OK, '1'); } catch (err) {} } return; }
        e.preventDefault();
        if (!i.value || i.value.indexOf('@') < 1) { i.focus(); return; }
        try { localStorage.setItem(K_OK, '1'); } catch (err) {}
        this.hidden = true;
        el.querySelector('.nl-code').textContent = CFG.code;
        el.querySelector('.nl-merci').hidden = false;
        el.querySelector('.nl-non').textContent = 'Fermer';
      });
    }

    /* Bandeau cookies (Shopify sur la boutique, le nôtre sur Vercel) encore à l'écran ? */
    function banniereVisible() {
      var b = document.querySelector('#shopify-pc__banner, .cookies');
      if (!b) return false;
      var r = b.getBoundingClientRect(), st = getComputedStyle(b);
      return r.height > 0 && st.display !== 'none' && st.visibility !== 'hidden';
    }
    function ouvrir(force) {
      if (ouvert || (!force && bloque())) return;
      /* Jamais par-dessus le bandeau cookies : sur téléphone, le bandeau (z-index
         2 000 000) recouvrait la fenêtre, ses boutons et son lien « Non merci »,
         le fond assombri bloquait la page et plus rien n'était cliquable
         (signalé par Nathan le 19 sept 2026). On attend qu'il ait disparu. */
      if (banniereVisible()) { clearTimeout(timer); timer = setTimeout(function () { ouvrir(force); }, 1500); return; }
      ouvert = true;
      clearTimeout(timer);
      if (!el) construire();
      avant = document.activeElement;
      el.classList.add('open');
      document.body.classList.add('nl-lock');
      var f = el.querySelector('input');
      if (f) setTimeout(function () { f.focus(); }, 60);
      document.addEventListener('keydown', clavier);
    }
    function fermer(memoriser) {
      if (!ouvert) return;
      ouvert = false;
      el.classList.remove('open');
      document.body.classList.remove('nl-lock');
      document.removeEventListener('keydown', clavier);
      if (memoriser) { try { localStorage.setItem(K_VU, String(Date.now())); } catch (e) {} }
      /* focus rendu sans défilement : sinon la page remontait jusqu'au dernier lien touché
         avant l'ouverture, souvent en haut de page (signalé par Nathan le 21/10/2026) */
      if (avant && avant.focus) avant.focus({ preventScroll: true });
    }
    function clavier(e) {
      if (e.key === 'Escape') { fermer(true); return; }
      if (e.key !== 'Tab') return;
      var f = el.querySelectorAll('button, input');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }

    /* Ouverture à la demande. Les textes peuvent être adaptés le temps d'une
       ouverture, et une étiquette supplémentaire permet de retrouver dans
       Clients qui attend quelle pièce. */
    function adapter(o) {
      if (!o) return;
      var t = { surtitre: '.nl-eyebrow', titre: '#nlTitre', texte: '.nl-txt' };
      for (var k in t) {
        if (o[k] == null) continue;
        var n = el.querySelector(t[k]); if (!n) continue;
        if (k === 'titre') { n.innerHTML = ''; n.appendChild(document.createTextNode(o.titre)); if (o.accent) { n.appendChild(document.createTextNode(' ')); var em = document.createElement('em'); em.textContent = o.accent; n.appendChild(em); } }
        else n.textContent = o[k];
      }
      if (o.bouton) { var b = el.querySelector('.nl-form button'); if (b) b.textContent = o.bouton; }
      if (o.tag) {
        var ch = el.querySelector('input[name="contact[tags]"]');   /* n'existe que sur le thème */
        if (ch && ch.value.indexOf(o.tag) === -1) ch.value = ch.value + ',' + o.tag;
      }
    }
    window.yoleteLettre = {
      ouvrir: function (options) { if (!el) construire(); adapter(options); ouvrir(true); }
    };

    /* ---------- Publicité (15 oct 2026, demande de Nathan : la N255 et les nouveautés) ----------
       Quand la section règle « Une publicité », l'ouverture automatique montre une photo
       et un bouton au lieu du formulaire. Les ouvertures à la demande (« Être prévenue »)
       gardent la lettre ci-dessus. Le refus est retenu par publicité : un nouveau titre
       la fait revenir chez ceux qui avaient fermé la précédente.
       Fréquence (20 oct 2026, Nathan : « à chaque fois qu'une personne arrive sur le site,
       même si elle est déjà venue ») : « visite », réglage par défaut, retient la fermeture
       le temps de la visite seulement (sessionStorage) ; « mois » la retient 30 jours. */
    var PUB = (CFG.mode === 'pub' && CFG.pub && CFG.pub.titre && CFG.pub.image) ? CFG.pub : null;
    var K_PUB = PUB ? 'yolete_pub_' + String(PUB.titre).toLowerCase().normalize('NFD').replace(/[^a-z0-9]+/g, '-') : '';
    var FREQ = (PUB && PUB.frequence === 'mois') ? 'mois' : 'visite';
    function memo() { return FREQ === 'visite' ? window.sessionStorage : window.localStorage; }
    var pubEl = null, pubOuverte = false, pubAvant = null;
    function suivre(nom, props) {
      try { if (window.yoTrack) window.yoTrack(nom, Object.assign({ campagne: K_PUB.replace('yolete_pub_', '') }, props || {})); } catch (e) {}
    }
    function pubBloquee() {
      try {
        var t = +memo().getItem(K_PUB) || 0;
        if (t && (FREQ === 'visite' || Date.now() - t < CFG.repos * 864e5)) return true;
      } catch (e) {}
      if (EXCLUES.some(function (p) { return location.pathname.indexOf(p) !== -1; })) return true;
      /* pas de publicité pour une pièce sur sa propre fiche */
      try { if (new URL(PUB.lien, location.href).pathname === location.pathname) return true; } catch (e) {}
      return false;
    }
    function construirePub() {
      pubEl = document.createElement('div');
      pubEl.className = 'nl-pop pub-pop';
      var y = (PUB.cadrage === '' || PUB.cadrage == null) ? 70 : +PUB.cadrage;
      /* « GOLD/ACAJOU/TOPAZE » -> « Acajou » : le métal et la pierre sont communs,
         c'est la teinte de l'émail qui distingue les finitions */
      function nomFinition(v) {
        var p = String(v || '').split('/').map(function (s) { return s.trim(); });
        var n = p.length === 3 ? p[1] : p.join(' ');
        return n.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
      }
      /* un petit mot (« À », « de »…) ne reste pas seul en fin de ligne */
      function insecables(s) {
        return String(s).replace(/(^|\s)(à|a|au|de|du|en|et|la|le|les|sur|nos|un|une)\s+/gi, '$1$2 ');
      }
      var fins = (PUB.finitions || []).filter(function (f) { return f && f.img; }).slice(0, 4);
      var finitions = fins.length > 1
        ? '<div class="pub-fins"><p class="pub-fins-titre">' + (fins.length === 2 ? 'Deux finitions' : fins.length + ' finitions') + '</p><div class="pub-fins-liste">' +
            fins.map(function (f) {
              return '<a class="pub-fin' + (f.dispo === false ? ' is-epuisee' : '') + '" href="' + ech(PUB.lien) + '" data-pub-clic="finition">' +
                '<span class="pub-fin-img"><img src="' + ech(f.img) + '" alt="" loading="lazy" /></span>' +
                '<span class="pub-fin-nom">' + ech(nomFinition(f.nom)) + '</span></a>';
            }).join('') + '</div></div>'
        : '';
      pubEl.innerHTML =
        '<div class="nl-back" data-pub-close></div>' +
        '<div class="pub-box" role="dialog" aria-modal="true" aria-labelledby="pubTitre" tabindex="-1">' +
          '<button class="nl-x pub-x" type="button" aria-label="Fermer" data-pub-close>&times;</button>' +
          '<a class="pub-media" href="' + ech(PUB.lien) + '" data-pub-clic="photo" tabindex="-1" aria-hidden="true">' +
            '<img src="' + ech(PUB.image) + '" alt="" decoding="async" style="--pub-y:' + y + '%" /></a>' +
          '<div class="pub-body">' +
            (PUB.logo ? '<img class="pub-logo" src="' + ech(PUB.logo) + '" alt="Yolète" />' : '') +
            '<div class="pub-centre">' +
              (PUB.surtitre ? '<p class="pub-eyebrow">' + ech(PUB.surtitre) + '</p>' : '') +
              '<h2 id="pubTitre">' + ech(PUB.titre) + '</h2>' +
              (PUB.prix ? '<p class="pub-prix">' + ech(PUB.prix) + '</p>' : '') +
              (PUB.texte ? '<p class="pub-txt">' + ech(insecables(PUB.texte)) + '</p>' : '') +
              finitions +
              '<a class="btn pub-cta" href="' + ech(PUB.lien) + '" data-pub-clic="bouton">' + ech(PUB.bouton || 'Découvrir') + '</a>' +
              (PUB.lien2Texte ? '<a class="pub-lien" href="' + ech(PUB.lien2) + '" data-pub-clic="second-lien">' + ech(PUB.lien2Texte) + '</a>' : '') +
            '</div>' +
            (PUB.mention ? '<p class="pub-mention">' + ech(PUB.mention) + '</p>' : '') +
          '</div>' +
        '</div>';
      document.body.appendChild(pubEl);
      pubEl.addEventListener('click', function (e) {
        var c = e.target.closest('[data-pub-clic]');
        if (c) {
          try { memo().setItem(K_PUB, String(Date.now())); } catch (err) {}
          suivre('pub_clic', { cible: c.getAttribute('data-pub-clic') });
          return;                                   /* le lien suit son cours */
        }
        if (e.target.closest('[data-pub-close]')) fermerPub();
      });
    }
    function ouvrirPub(force) {
      if (pubOuverte || ouvert || (force !== true && pubBloquee())) return;
      if (force !== true && banniereVisible()) { clearTimeout(timer); timer = setTimeout(ouvrirPub, 1500); return; }
      pubOuverte = true;
      clearTimeout(timer);
      if (!pubEl) construirePub();
      pubAvant = document.activeElement;
      pubEl.classList.add('open');
      document.body.classList.add('nl-lock');
      /* le focus va à la fenêtre, pas au bouton : sinon son contour s'affiche d'office */
      var boite = pubEl.querySelector('.pub-box');
      setTimeout(function () { boite.focus({ preventScroll: true }); }, 60);
      document.addEventListener('keydown', clavierPub);
      suivre('pub_vue');
    }
    function fermerPub() {
      if (!pubOuverte) return;
      pubOuverte = false;
      pubEl.classList.remove('open');
      document.body.classList.remove('nl-lock');
      document.removeEventListener('keydown', clavierPub);
      try { memo().setItem(K_PUB, String(Date.now())); } catch (e) {}
      suivre('pub_fermee');
      if (pubAvant && pubAvant.focus) pubAvant.focus({ preventScroll: true });   /* voir fermer() */
    }
    function clavierPub(e) {
      if (e.key === 'Escape') { fermerPub(); return; }
      if (e.key !== 'Tab') return;
      var f = pubEl.querySelectorAll('.pub-x, .pub-cta, .pub-lien');
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
    /* aperçu sans attendre ni refus mémorisé : ?fenetre=pub (ou =lettre) */
    try {
      var apercu = new URLSearchParams(location.search).get('fenetre');
      if (apercu === 'pub' && PUB) { try { memo().removeItem(K_PUB); } catch (e) {} setTimeout(ouvrirPub, 600); }
      else if (apercu === 'lettre') setTimeout(function () { ouvrir(true); }, 600);
    } catch (e) {}
    if (PUB) auto = !pubBloquee() && !(window.Shopify && Shopify.designMode);
    var ouvrirAuto = PUB ? ouvrirPub : ouvrir;

    if (auto) {
      timer = setTimeout(ouvrirAuto, CFG.delai);
      /* consentement donné ou refusé : la fenêtre peut venir, après une respiration */
      document.addEventListener('visitorConsentCollected', function () { clearTimeout(timer); timer = setTimeout(ouvrirAuto, 2000); });
      window.addEventListener('scroll', function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= CFG.defilement) ouvrirAuto();
      }, { passive: true });
      if (CFG.sortie && !matchMedia('(hover: none)').matches) {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0) ouvrirAuto();
        });
      }
    }

    /* ---------- Aperçu dans Personnaliser (20 oct 2026, pour Charlotte) ----------
       Dans l'éditeur de thème, la fenêtre ne s'ouvre pas seule (elle couvrirait l'aperçu
       de toutes les pages). Elle s'ouvre quand on sélectionne sa section « Yolète ·
       Fenêtre lettre », se refait à chaque réglage modifié, et se ferme quand on passe
       à une autre section. Elle montre ce que règle « Ce que montre la fenêtre ». */
    if (window.Shopify && Shopify.designMode) {
      var estLaSection = function (e) {
        var id = String((e.detail && e.detail.sectionId) || '') + ' ' + String((e.target && e.target.id) || '');
        return id.indexOf('yolete-newsletter-popup') !== -1;
      };
      var fermerApercu = function () {
        if (pubOuverte) { pubOuverte = false; pubEl.classList.remove('open'); document.removeEventListener('keydown', clavierPub); }
        if (ouvert) fermer(false);
        document.body.classList.remove('nl-lock');
      };
      var montrerApercu = function () {
        fermerApercu();
        if (PUB) ouvrirPub(true); else ouvrir(true);
      };
      /* réglages modifiés : la section est rendue à nouveau, on relit ses valeurs et on refait les fenêtres */
      var relire = function (section) {
        var s = section && section.querySelector && section.querySelector('script');
        if (s && /YOLETE_NL/.test(s.textContent)) { try { new Function(s.textContent)(); } catch (err) {} }
        var N = window.YOLETE_NL || {};
        for (var k in N) { var v = N[k]; if (v !== '' && v !== null && v !== undefined) CFG[k] = v; }
        PUB = (CFG.mode === 'pub' && CFG.pub && CFG.pub.titre && CFG.pub.image) ? CFG.pub : null;
        K_PUB = PUB ? 'yolete_pub_' + String(PUB.titre).toLowerCase().normalize('NFD').replace(/[^a-z0-9]+/g, '-') : '';
        FREQ = (PUB && PUB.frequence === 'mois') ? 'mois' : 'visite';
        fermerApercu();
        if (pubEl) { pubEl.remove(); pubEl = null; }
        if (el) { el.remove(); el = null; }
      };
      document.addEventListener('shopify:section:select', function (e) { if (estLaSection(e)) montrerApercu(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (estLaSection(e)) fermerApercu(); });
      document.addEventListener('shopify:section:load', function (e) { if (estLaSection(e)) { relire(e.target); montrerApercu(); } });
    }
  })();

  /* ---------- 12. Formulaires .yform (contact, revendeur) ----------
     Sur Shopify (data-native="1", posé par le build) le navigateur envoie le
     formulaire natif et Shopify l'achemine vers la boîte de la boutique.
     Sur la version statique, aucun serveur : on compose un courriel prérempli
     avec tous les champs, que le client n'a plus qu'à envoyer. */
  (function () {
    var forms = [].slice.call(document.querySelectorAll('form.yform'));
    forms.forEach(function (f) {
      f.addEventListener('submit', function (e) {
        var ok = true;
        [].slice.call(f.querySelectorAll('[required]')).forEach(function (el) {
          var bad = el.type === 'checkbox' ? !el.checked : !el.value.trim()
                 || (el.type === 'email' && el.value.indexOf('@') < 1);
          var box = el.closest('.yf-field') || el.closest('.yf-consent');
          if (box) box.classList.toggle('is-error', !!bad);
          if (bad) ok = false;
        });
        if (!ok) { e.preventDefault(); return; }
        if (f.dataset.native === '1') return;          /* Shopify : envoi natif */
        e.preventDefault();
        var lines = [];
        [].slice.call(f.elements).forEach(function (el) {
          if (!el.name || el.type === 'submit' || el.type === 'checkbox') return;
          var label = (el.name.match(/contact\[(.+)\]/) || [0, el.name])[1];
          var noms = { name: 'Nom', email: 'Courriel', phone: 'Téléphone', body: 'Message' };
          lines.push((noms[label] || label) + ' : ' + el.value);
        });
        var sujet = f.dataset.yform === 'revendeur' ? 'Demande revendeur Yolète' : 'Contact depuis le site Yolète';
        var href = 'mailto:contact@yolete.fr?subject=' + encodeURIComponent(sujet)
                 + '&body=' + encodeURIComponent(lines.join('\n'));
        window.location.href = href;
        var done = f.querySelector('.yf-done');
        if (done) { done.hidden = false; done.textContent = 'Votre messagerie s\'ouvre avec le message prérempli. Il ne reste qu\'à l\'envoyer.'; }
      });
    });
  })();

  /* ============================================================
     14. Bandeau de consentement, hauteur réservée
     Sur téléphone, le panneau de Shopify occupe la moitié basse de l'écran.
     Le choix de largeur du composeur tombait dessous et devenait impossible
     à toucher (signalé le 20 septembre). On réserve sa hauteur en bas de
     page tant qu'il est affiché, le contenu peut donc être amené au-dessus.
     ============================================================ */
  (function () {
    var applique = 0;
    function ajuster() {
      var b = document.getElementById('shopify-pc__banner');
      /* offsetParent vaut null pour un élément en position fixe, ce qui est le
         cas du bandeau : il faut mesurer le rectangle et lire le style. */
      var h = 0;
      if (b) {
        var st = getComputedStyle(b);
        if (st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0') h = Math.round(b.getBoundingClientRect().height);
      }
      if (h === applique) return;
      applique = h;
      document.body.style.paddingBottom = h ? (h + 16) + 'px' : '';
      /* Sur téléphone le panneau occupe la moitié basse. Le composeur épingle
         l'aperçu sur la moitié haute, les options se retrouvaient prises en
         étau et aucune n'était touchable tant que le visiteur n'avait pas
         répondu. La classe permet de rendre l'aperçu à sa place le temps du
         bandeau, sans toucher à la mise en page validée. */
      document.body.classList.toggle('consent-ouvert', h > 0);
    }
    function suivre() {
      ajuster();
      try {
        new MutationObserver(ajuster).observe(document.body, { childList: true, subtree: false });
        window.addEventListener('resize', ajuster);
        document.addEventListener('visitorConsentCollected', function () { setTimeout(ajuster, 60); });
      } catch (e) {}
      /* le bandeau arrive après le reste de la page, on repasse deux fois */
      setTimeout(ajuster, 600); setTimeout(ajuster, 2000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suivre);
    else suivre();
  })();

})();
